export default {
  SET_ITEMS (state, data) {
    state.items = data
  },
  SET_PROJECTS (state, data) {
    state.projects = data
  },
  SET_BOTS (state, data) {
    state.bots = data
  },
  ADD_BOT (state, bot) {
    state.bots.data.unshift(bot);
  },
  SET_PLAYBOOKS (state, data) {
    state.playbooks = data
  },
  SET_STAT_AGGR_V2 (state, data) {
    state.stats.aggrV2 = data
  },
  SET_STAT_AGRR_DAY (state, data) {
    state.stats.aggrDate = data
  },
  FULL_PROJECT_RELOADED (state, data) {
    
  },
  SET_STAT_REPORT (state, data) {
    state.stats.report = data
  },
  SET_STATS_BY_DATE (state, data) {
    state.stats.byDate = data
  },
  SET_STATS_BY_ERRORS (state, data) {
    state.stats.byErrors = data
  },
  SET_ADVANCED_SETTINGS (state, data) {
    state.advanced = data
  },
  SET_PLAYBOOK_ADVANCED (state, data) {
    data.data.profile_usage_returning = parseFloat(data.data.profile_usage_returning);
    state.playbookAdvanced = data;
  },
  SET_PB_LOADING (state, status) {
    state.pb_loading = status
  },
  DELETE_PLAYBOOK_ADVANCED (state, data) {
    //state.playbookAdvanced = data.data
  },
  SET_PAGINATION (state, payload) {
    state.pagination = {
      page: payload.page || state.pagination.page,
      limit: payload.limit || state.pagination.limit,
      total: payload.total || state.pagination.total
    }
  },
  UPDATE_BOT_STORE(state, payload) {
    if (typeof(state.bots.data) == 'undefined') return 0;
    var dispatchId = 0; //in case of goal setting its payload.data.id;
    //in case of advanced settings its  payload.bot_id and adv.id is payload.response.data.id
    if (typeof(payload.bot_id) !== 'undefined') {
      var filteredEntity = state.bots.data.filter(function(entity){
        if (entity.id == payload.bot_id) {
          return entity;
        }
      })[0];
  
      
      filteredEntity.advanced_settings_id = payload.response.data.id;
      var index = state.bots.data.indexOf(filteredEntity);
      state.bots.data[index] = filteredEntity;
    }
  },
  DELETED_PLAYBOOK_ADVANCED (state, payload) {    
    var filteredEntity = state.bots.data.filter(function(entity){
      if (entity.id == payload.bot_id) {
        return entity;
      }
    })[0];
    
    var index = state.bots.data.indexOf(filteredEntity);
    var cleanedUp = state.bots.data.filter(function(entity){
      if (entity.id != payload.bot_id) {
        return entity;
      }
    });

    filteredEntity.advanced_settings_id = state.advanced.data.id;
    cleanedUp[index] = filteredEntity;
    state.bots.data = cleanedUp;
  },

  SET_ERROR (state, data) {
    state.error = data
  },

  SET_LOADING (state, data) {
    state.loading = data
  },

  CREATE_PLAYBOOK_RESPONSE_DATA(state,data) {
    state.playbooks.data.push(data);
    state.playbooksEdits.result = data;
  },
  DELETE_PLAYBOOK_RESPONSE_DATA(state,data) {
    var result = state.playbooks.data.filter(function(entity){
        if (entity.id != data.id) {
          return entity;
        }
      });
    state.playbooks.data = result;
  },
  UPDATE_PLAYBOOK_RESPONSE_DATA(state,data) {

  },

  DELETED_BOT(state,data) {
    var result = state.bots.data.filter(function(entity){
      if (entity.id != data.id) {
        return entity;
      }
    });
    state.bots.data = result;
    state.loading = false;
  },

  BOT_RAN_NOW(state,data) {
    state.loading = false;
  },
  CHANGED_PROJECT_STATE(state,data){
    if (data) {
      state.projects.data.status = 'active';
    } else {
      state.projects.data.status = 'inactive';
    }
  },
  SET_PROJECT_VIEW(state, value) {
    state.view = value;
  },

  DISTRIBUTION_SET(state, value) {
    
  },
  SET_BOT_REPORT (state, data) {
    var botId = data.payload.bot_id
    var report = { [botId]: data.response }
    var index = state.stats.botReport.findIndex(function (item) {
      return parseInt(Object.keys(item)[0]) === parseInt(botId)
    })

    if (index === -1) {
      state.stats.botReport.push(report)
    } else {
      state.stats.botReport.splice(index, 1, report)
    }
  },
  BOT_UPDATED(state, data) {
    if (typeof(state.bots.data) == 'undefined') return 0;
    var result = state.bots.data.filter(function(entity) {
      if (entity.id == data.id) {
        entity.status = data.status;
      } 
      return entity;
    });
    
    state.bots.data = result;  
  },

  REFRESH_BOTS(state, data) {

  },
  SET_ACCOUNT_GROUPS(state, data) {
    state.accounts = data.data;
  },
  SET_PROXIES_IDS(state, data) {
    state.proxies = data.data;
  },
  SET_PROXIES_TAGS(state, data) {
    state.proxies_tags = data.data;
  },
  SET_LANGUAGES(state, data) {
    state.languages = data.data;
  },
  SET_POOLS(state, data) {
    // The only place i found to properly flatten pools to use as tags
    state.pools = data.data.map(e => e.name);
  },
  PROJECT_COPIED(state, data) {

  },

}
